import { IonIcon } from '@ionic/react';
import Titlebar from 'components/core/Titlebar';
import {
    checkmark,
    globeOutline,
    images,
    locate,
    logoAppleAppstore,
    sparkles,
} from 'ionicons/icons';
import { useState } from 'react';
import { HStack, VStack } from 'reaction';
import styles from './Services.module.css';

interface ServiceTogglerProps {
    label: string;
    gradient: [string, string];
    contrast?: 'black' | 'white';
    icon: string;
}

function Services() {
    return (
        <VStack className={styles.Services} justify='start' height='100vh'>
            <Titlebar title='Services' />
            <HStack>
                <VStack align='start'>
                    <ServiceToggler
                        label='Web Development'
                        icon={globeOutline}
                        gradient={['#B800F2', '#FF016E']}
                    />
                    <ServiceToggler
                        label='Mobile Development'
                        icon={logoAppleAppstore}
                        gradient={['#91FF24', '#E0FF24']}
                        contrast='black'
                    />
                    <ServiceToggler
                        label='Brand Management'
                        icon={sparkles}
                        gradient={['#8B002F', '#FF1AA1']}
                    />
                    <ServiceToggler
                        label='Advertising'
                        icon={locate}
                        gradient={['#FF3F00', '#FFBF00']}
                        contrast='black'
                    />
                    <ServiceToggler
                        label='Graphic Design'
                        icon={images}
                        gradient={['#8721FF', '#00B6FF']}
                    />
                </VStack>
                <VStack grow={1}>Hello World!</VStack>
            </HStack>
        </VStack>
    );
}

function ServiceToggler({
    icon,
    label,
    gradient: [colorStart, colorStop],
    contrast = 'white',
}: ServiceTogglerProps) {
    const [hovering, setHovering] = useState(false);
    const hoveredStyles = {
        backgroundImage: `linear-gradient(to right, ${colorStart}, ${colorStop})`,
        color: contrast,
        fontWeight: 'bold',
    };
    const defaultStyles = {
        borderLeft: `1rem solid ${colorStart}`,
    };

    function buildStyles() {
        if (hovering) {
            return {
                ...defaultStyles,
                ...hoveredStyles,
            };
        } else {
            return defaultStyles;
        }
    }

    return (
        <button
            className={styles.ServiceToggler}
            style={buildStyles()}
            onMouseOver={() => setHovering(true)}
            onMouseOut={() => setHovering(false)}>
            <HStack justify='start' height='100%'>
                <IonIcon icon={icon} />
                <h2>{label}</h2>
            </HStack>
        </button>
    );
}

export default Services;
export { ServiceToggler };
export type { ServiceTogglerProps };
